/**
 * This is the parent object for all stores.
 */

const GenericStore = {
  callbacks: [],

  _reset: function() {
    this.callbacks = [];
  },

  emitChange: function() {
    this.callbacks.forEach((cb) => {
      cb();
    });
  },

  addChangeListener: function(cb) {
    this.callbacks.push(cb);
  },

  removeChangeListener: function(cb) {
    const index = this.callbacks.indexOf(cb);
    if (index > -1) {
      this.callbacks.splice(index, 1);;
    }
  }
};

export default GenericStore;
